<script setup>
import FormGroup from '@maison/components/form/FormGroup.vue';
import { PhxIcon, PhxStrapFinderVideo } from '@phx-styleguides/iwc';
import { computed } from 'vue';
import { emits as defaultEmits, props as defaultProps, useSection } from '@maison/composables/strapFinder/useSection';
import RadioListField from '@maison/components/form/fields/RadioListField.vue';
import { useI18n } from 'vue-i18n';
import ConfiguratorSectionLayout from '@maison/components/strapFinder/sections/ConfiguratorSectionLayout.vue';

const props = defineProps({
  ...defaultProps,
  video: {
    type: Object,
    required: true,
  },
  selectedStrap: {
    type: Object,
    default: null,
  },
});

defineEmits(defaultEmits);

const { id, preTitle, nextSectionId } = useSection('strap-size');

const currentStrapSize = defineModel('currentStrapSize', {
  type: String,
  required: true,
});

const { t } = useI18n();

const strapSizeField = computed(() => {
  if (!props.selectedStrap) return null;

  return {
    id: id.value,
    name: id.value,
    label: '',
    options: Object.entries(props.selectedStrap.sizes).map(([size, { priceWithCurrency, inStock, sellable }]) => ({
      id: size,
      value: size,
      label: t('StrapFinderConfigurator.sizes.' + size),
      additionalContent: priceWithCurrency,
      disabled: !inStock || !sellable,
    })),
  };
});
</script>

<template>
  <configurator-section-layout
    :id="id"
    :title="title"
    :description="description"
    :memo="memo"
    :pre-title="preTitle"
    :next-section-id="nextSectionId"
  >
    <template #media>
      <phx-strap-finder-video v-bind="video" :id="`${id}-video`" />
    </template>

    <template #default>
      <form v-if="strapSizeField" @submit.prevent.stop @change="$emit('onStepValidate', $event, id)">
        <form-group :attrs="strapSizeField" :is-fieldset="true">
          <radio-list-field v-model="currentStrapSize" type="rich" />
        </form-group>

        <div v-if="!strapSizeField.options.some((option) => !option.disabled)">
          <div class="alert box box--solid box--spacing-2 box--inverted mt-4">
            <div>
              <phx-icon icon="info" />
            </div>

            <div class="stack stack--spacing-2">
              <h5 class="heading-small">
                {{ t('StrapFinderConfigurator.noAvailableSizes.title') }}
              </h5>

              <div class="rich-text">
                <p>{{ t('StrapFinderConfigurator.noAvailableSizes.text') }}</p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </configurator-section-layout>
</template>
